<template>
    <div class="score-tip-popper">
        <table cellspacing="0" cellpadding="0" border="0" class="tips-pop-table">
            <div class="tip-head">
                <thead>
                    <tr v-if="queryType==='1' || queryType==='2' || queryType==='3'|| queryType===''">
                        <th colspan="2" width="91">评分参考<br/>标准：</th><th width="130">参考问题</th><th width="240">S</th><th width="150">A</th><th width="150">B</th><th width="150">C</th><th width="100">D</th><th width="41">评分</th>
                    </tr>
                    <tr v-if="queryType=== '4' || queryType === '5'">
                        <th colspan="2" width="91">评分参考<br/>标准：</th><th width="130">参考问题</th><th width="240"><span class="orange">S</span></th><th width="150"><span class="yellow" >A</span></th><th width="150"><span class="blue">B</span></th><th width="150"><span class="green">C</span></th><th width="100"><span class="black">D</span></th><th width="41">评分</th>
                    </tr>
                    <tr v-if="queryType==='8'">
                        <th colspan="2" width="100">评分参考<br/>标准：</th><th width="160">参考问题</th><th width="160"><span class="orange">S</span></th><th width="160"><span class="yellow" >A</span></th><th width="150"><span class="blue">B</span></th><th width="150"><span class="green">C</span></th><th width="150"><span class="black">D</span></th><th width="31">评分</th>
                    </tr>
                    <tr v-if="queryType==='7'">
                        <th colspan="2" width="91">评分参考<br/>标准：</th><th width="248">S[9,10]</th><th width="208">A[7,9)</th><th width="187">B[4-7)</th><th width="299">C[0-4)</th><th width="41">评分</th>
                    </tr>
                    <tr v-if="queryType==='14'">
                        <th width="112">考察维度</th><th width="250">考察点</th><th width="100">分数（5分制）</th><th width="678">分数定义</th>
                    </tr>
                    <tr v-if="queryType==='15'">
                        <th width="134">考察维度</th><th width="258">考察点</th><th width="100">分数（5分制）</th><th width="678">分数定义</th>
                    </tr>
                    <tr v-if="queryType==='16'">
                        <th width="114">考察维度</th><th width="250">考察点</th><th width="100">分数（5分制）</th><th width="680">分数定义</th>
                    </tr>
                </thead>
            </div>
            <div class="tip-body">
                <tester-detail v-if="queryType==='1' || queryType==='2' || queryType==='3'|| queryType===''"></tester-detail>
                <gzRecruitment2020Detail v-else-if="queryType==='4'" />
                <hzRecruitment2020DetailFirst v-else-if="queryType==='5'&&queryTurn === '0'" />
                <hzRecruitment2020DetailSecond v-else-if="queryType==='5'&&queryTurn !== '0'" />
                <gzRecruitment2021Detail v-else-if="queryType==='9'" />
                <hzRecruitment2021DetailFirst v-else-if="queryType==='10'&&queryTurn === '0'" />
                <hzRecruitment2021DetailSecond v-else-if="queryType==='10'&&queryTurn !== '0'" />
                <social-qa v-else-if="queryType ==='7'"></social-qa>
                <verify-qa v-else-if="queryType==='8'"></verify-qa>
                <gametest-detail v-else-if="queryType==='14'"></gametest-detail>
                <softwaretestdev-deatail v-else-if="queryType==='15'"></softwaretestdev-deatail>
                <softwaretest-deatail v-else-if="queryType==='16'"></softwaretest-deatail>
                <hzShRecruitment2022DetailFirst v-else-if="queryType==='17'&&queryTurn === '0'"/>
                <hzShRecruitment2022DetailSecond v-else-if="queryType==='17'&&queryTurn !== '0'"/>
                <gzGameTest2022Detail v-else-if="queryType==='18'"/>
                <gzSoftWaretest2022Detail v-else-if="queryType==='19'"/>
                <gzSoftWaretestdev2022Detail v-else-if="queryType==='20'"/>
                <hzShSoftGametest2022DetailFirst v-else-if="queryType==='21'&&queryTurn === '0'"/>
                <hzShSoftGametest2022DetailSecond v-else-if="queryType==='21'&&queryTurn !== '0'"/>
                <hzShSoftWaretest2022DetailFirst v-else-if="queryType==='22'&&queryTurn === '0'"/>
                <hzShSoftWaretest2022DetailSecond v-else-if="queryType==='22'&&queryTurn !== '0'"/>
                <hzShSoftGametestdev2022DetailFirst v-else-if="queryType==='23'&&queryTurn === '0'"/>
                <hzShSoftGametestdev2022DetailSecond v-else-if="queryType==='23'&&queryTurn !== '0'"/>
                <lqa2022DetailFirst v-else-if="queryType==='24'&&queryTurn === '0'"/>
                <lqa2022DetailSecond v-else-if="queryType==='24'&&queryTurn !== '0'"/>
            </div>
        </table>
    </div>
</template>
<script>
    import TesterDetail from './score-tips-tester.vue'
    import LangtesterDetail from './score-tips-langtester.vue'
    import DevelopDetail from './score-tips-develop.vue'
    // import GungzhourecruitmentDetail from './score-tips-2021recruitment-guangzhou'
    // import HangzhourecruitmentDetailFirst from './score-tips-2021recruitment-hangzhou-first'
    // import HangzhourecruitmentDetailSecond from './score-tips-2021recruitment-hangzhou-second'
    import VerifyQa from './score-tips-verify-qa'
    import SocialQa from './score-tips-2020-social-qa'
    export default {
        components: {
            TesterDetail,
            LangtesterDetail,
            DevelopDetail,
            gzRecruitment2020Detail: () => import('./score-tips-2020recruitment-guangzhou'),
            hzRecruitment2020DetailFirst: () => import('./score-tips-2020recruitment-hangzhou-first'), 
            hzRecruitment2020DetailSecond: () => import('./score-tips-2020recruitment-hangzhou-second'),
            gzRecruitment2021Detail: () => import('./score-tips-2021recruitment-guangzhou'),
            hzRecruitment2021DetailFirst: () => import('./score-tips-2021recruitment-hangzhou-first'), 
            hzRecruitment2021DetailSecond: () => import('./score-tips-2021recruitment-hangzhou-second'),
            GametestDetail: () => import('./score-tips-2021gametest'),
            softwaretestdevDeatail: () => import('./score-tips-2021softwaretest-dev'),
            softwaretestDeatail: () => import('./score-tips-2021softwaretest'),
            hzShRecruitment2022DetailFirst: () => import('./score-tips-2022recruitment-hz&sh-first'),
            hzShRecruitment2022DetailSecond: () => import('./score-tips-2022recruitment-hz&sh-second'),
            gzGameTest2022Detail: () => import('./score-tips-2022gametest-guangzhou'),
            gzSoftWaretest2022Detail: () => import('./score-tips-2022softwaretest-guangzhou'),
            gzSoftWaretestdev2022Detail: () => import('./score-tips-2022softwaretest-dev-guangzhou'),
            // #50197 互娱外包招聘系统-笔试评分表迭代
            hzShSoftGametest2022DetailFirst: () => import('./score-tips-2022gametest-hz&sh-first'), // 21
            hzShSoftGametest2022DetailSecond: () => import('./score-tips-2022gametest-hz&sh-second'), // 21
            hzShSoftWaretest2022DetailFirst: () => import('./score-tips-2022softwaretest-hz&sh-first'), // 22
            hzShSoftWaretest2022DetailSecond: () => import('./score-tips-2022softwaretest-hz&sh-second'), // 22
            hzShSoftGametestdev2022DetailFirst: () => import('./score-tips-2022gametest-dev-hz&sh-first'), // 23
            hzShSoftGametestdev2022DetailSecond: () => import('./score-tips-2022gametest-dev-hz&sh-second'), // 23
            lqa2022DetailFirst: () => import('./score-tips-2022lqa-first'), // 24
            lqa2022DetailSecond: () => import('./score-tips-2022lqa-second'), // 24
            SocialQa,
            VerifyQa
        },
        computed: {
            queryType () {
                return this.$route.query.scoreType || this.type
            },
            queryTurn () {
                if (this.$route.meta.template && this.$route.meta.template === 'full') {
                    return this.$route.query.turn
                }else{
                    return this.turn
                }
            }
        },
        props: {
            type: {
                default: '1',
                type: String
            },
            turn: {
                default: '',
                type: String
            }
        },
    }
</script>
<style lang="scss">
    .score-tip-popper{
        position: absolute;
        background: #fff;
        z-index: 9;
        top: 57px;
        left: 0;
        box-shadow: 1px 1px 1px #ddd;
        border-radius: 5px;
        .tips-pop-table{
            td,th{
                border: 1px solid #ddd;
                padding: 5px;
            }
            .fb{
                font-weight: bold;
            }
        }
        .tip-head{
            width:1140px
        }
        .tip-body{
            width:1140px;
            height: 600px;
            overflow-y: auto;
        }
    }
    // body[data-root="scoreTips"]{
    //     // overflow: hidden;
    // }
    .scoped-scoreTips{
        width: 1140px;
        position: static;
        margin:40px auto;
        padding: 20px;
        border-top:none;
        
        .tips-pop-table{
            position: relative;
            .tip-head{
                tr{
                    width:100%;
                    border-top: 1px solid #ddd;
                }
                background: #fff;
                width: 1141px;
                th{
                    border-top:none;
                }
            }
            .tip-body{
                width:1140px;
                height: calc(100vh - 140px);
                overflow-y: auto;
                border-bottom: 1px solid #ddd;
            }
        }
    }
  @import './tips-colors.css';
</style>


// WEBPACK FOOTER //
// score-tips.vue?e72efc3c